
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import TodayCollection from "../components/todayCollection";
import Footer from "../components/footer";

function TodayCollectionPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <TodayCollection /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default TodayCollectionPage;
